import { accountDeletionQueryKeys as e } from "./useAccountDeletionQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { accountDeletionApi as n } from "@maat/api-main";
//#region src/account-deletion/useAccountDeletionBlockersQuery.ts
var r = (r = !0) => t({
	queryKey: e.blockers(),
	queryFn: n.getBlockers,
	enabled: r,
	staleTime: 0,
	refetchOnMount: "always",
	refetchOnWindowFocus: !1
});
//#endregion
export { r as useAccountDeletionBlockersQuery };
